module.exports = __webpack_public_path__ + "static/media/identity.9792d044.obj";